module.exports = __webpack_public_path__ + "static/img/3s-platform-img5.eadf44f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-img5.png
// module id = FZ4f
// module chunks = 0